import React from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";

interface Date{
  mese:string;
  anno:string;
}
interface TeamProps {
  date?: Date;
  color?: string;
  title?: string;
  subtitle?: string;
}

class JourneyCircle extends React.Component<TeamProps> {
    render() {
      const { date, color, title, subtitle } = this.props;
  
      return (
        <div className="flex flex-col items-center justify-center text-white w-full py-8">
          <div className="relative w-24 h-24 md:w-48 md:h-48 lg:w-52 lg:h-52">
            <div
              className="rounded-full w-full h-full object-cover flex items-center justify-center"
              style={{
                border: `2px solid ${color}`,
              }}
            >
             <div
              className="rounded-full w-full h-full object-cover flex items-center justify-center flex-col"
              style={{
                border: `2px solid ${color}`,
              }}
            >
            
            <span className="uppercase text-xs md:text-xl font-bold" >{date?.mese}</span>
            <span className="uppercase md:text-xl font-bold" >{date?.anno}</span>
            </div>
            </div>
          </div>
          <div className="flex-col text-center mt-4 ">

          <p className=" font-bold"><ReactMarkdown remarkPlugins={[remarkBreaks]}>{title}</ReactMarkdown></p>
          <p className="font-bold ">{subtitle}</p>
          </div>
        </div>
      );
    }
  }

export default JourneyCircle;